<template>
  <el-form label-position="top" :model="form" :rules="rules" ref="form_create">
    <!-- <h2 class="title">Nuevo documento</h2> -->

    <el-form-item label="Fecha de Vencimiento" style="font-weight: bold">
      <el-date-picker
        v-model="LegalDocumentModel.DueDate"
        type="date"
        placeholder="Fecha de Vencimiento"
      >
      </el-date-picker>
    </el-form-item>

    <!-- TODO: Colocar una mejor forma de manejar el action del el-upload debido a que esta fue la única forma que me funcionó pero no es lo más legible -->
    <el-form-item label="Adjuntar documento" style="font-weight: bold">
      <el-upload
        ref="uploadFile"
        class="upload-demo"
        action="#"
        :drag="true"
        :auto-upload="false"
        :multiple="true"
        :limit="1"
        :file-list="fileList"
        :on-exceed="handleExceed"
        :on-error="handleUploadOnError"
        :before-upload="hableBeforeUpload"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Suelta tu archivo aquí o <em>haz clic para cargar</em>
        </div>
        <div slot="tip" class="el-upload__tip">
          Solo archivos con un tamaño menor de 26MB
        </div>
      </el-upload>
    </el-form-item>
    <el-button @click="onCancel" size="mini">Cancel</el-button>
    <el-button
      id="btnSave"
      type="primary"
      size="mini"
      :loading.sync="saveLoading"
      @click="saveDocument"
      >Guardar</el-button
    >
  </el-form>
</template>

<script>
import { formatDate } from "@/utils";
import MixinDocumment from "@/components/MixinUploadDocument.vue";

export default {
  name: "NewDocument",
  props: {
    RowDocumentId: {
      type: Number,
      default: 0
    },
    RowDocumentDueDate: {
      type: String,
      default: ""
    },
    Company: {
      type: String,
      default: ""
    }
  },
  mixins: [MixinDocumment],
  data() {
    return {
      fileList: [],
      formatDueDate: "",
      saveLoading: false,
      LegalDocumentModel: {
        DocumentId: 0,
        CreatedAt: "",
        DueDate: "",
        LastUpdated: ""
      },
      documentName: ""
    };
  },
  created() {
    if (this.RowDocumentId && this.RowDocumentDueDate) {
      this.LegalDocumentModel.DueDate = this.RowDocumentDueDate;
    } else {
      this.LegalDocumentModel.LastUpdated = this.DateFormatter(new Date());
    }
  },
  methods: {
    DateFormatter(date) {
      return formatDate(date, "YYYY-MM-DDTHH:mm:ss.SSS");
    },
    handleExceed() {
      this.$message({
        type: "warning",
        message: "Solo se permite subir un archivo a la vez"
      });
    },

    // eslint-disable-next-line no-unused-vars
    handleUploadOnError(error) {
      this.$message({
        type: "error",
        message: error
      });
      this.saveLoading = false;
      this.LegalDocumentModel.DueDate = "";
      this.fileList = [];
    },
    hableBeforeUpload(document) {
      this.saveLoading = true;
      var fdata = new FormData();
      fdata.append("document", document);

      //Se pasó los parámetros en el URI del post porque no se podía pasar en el body junto con el archivo.
      this.$http
        .post(
          `/api/LegalDocuments/UploadDocument?Id=${this.RowDocumentId}&DueDate=${this.formatDueDate}&LastUpdated=${this.LegalDocumentModel.LastUpdated}&UpdatedByUser=${this.currentUser.UserID}&CompanyId=${this.Company}`,
          fdata
        )
        .then((response) => {
          var result = response.data.replace(
            '<string xmlns="http://schemas.microsoft.com/2003/10/Serialization/">',
            ""
          );
          result = result.replace("</string>", "");
          if (result === "Archivo Vacío") {
            this.$message({
              type: "error",
              message: result
            });
          } else if (
            result === "Archivo Subido con Éxito" ||
            result === "Archivo Actualizado con Éxito"
          ) {
            this.$message({
              type: "success",
              message: result
            });
          } else {
            this.$message({
              type: "error",
              message: result
            });
          }
        })
        .finally(() => {
          this.onCancel();
          this.$emit("getData");
        });

      return false;
    },
    saveDocument() {
      this.$refs.form_create.validate((valid) => {
        if (valid) {
          if (this.LegalDocumentModel.DueDate === "") {
            this.$message.error(
              "Favor especificar la fecha en que vence el documento"
            );
            return false;
          } else {
            this.formatDueDate = this.DateFormatter(
              this.LegalDocumentModel.DueDate
            );
            this.$refs.uploadFile.submit();
            return true;
          }
        }
      });
    },
    onCancel() {
      this.fileList = [];
      this.saveLoading = false;
      this.$emit("dialog-closed");
      this.LegalDocumentModel.DueDate = "";
    }
  }
};
</script>
